export default {
  personal_data: 'Contact Details',
  personal_data__hint: 'Please check the information below.',
  onboarding: 'Organizational matters',
  documents: 'Employment documents',
  general_info: 'General information',
  general_info__hint:
    'Please check the information below and speak with HR if you have any questions.',
  start_date: 'Start date',
  position: 'Position',
  department: 'Department',
  project: 'Project',
  manager: 'Manager',
  mentor: 'Mentor',
  hr_organizer: 'HR',
};
